import * as React from 'react';

import styled from '@emotion/styled';

/**
 * Resetting styles
 * 1. gui_def .form_field_holder_flat - assets/scss/components/_views.scss
 */
const StyledTable = styled.table`
  .form_field_holder_flat {
    height: 100%;
    vertical-align: unset;
  }
`;

interface Props {
  title: string;
}

export const GuiDefGroup: React.FC<Props> = ({ title, children }) => {
  return (
    <StyledTable>
      <tbody>
        <tr className="view_field_box">
          <td className="view_field_box">
            <table>
              <tbody>
                <tr>
                  <td className="form_field_holder_flat">
                    <h3>{title}</h3>
                    {children}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </StyledTable>
  );
};
